import { render } from "./index.vue?vue&type=template&id=4b792797&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4b792797&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=4b792797&lang=less"
script.render = render
script.__scopeId = "data-v-4b792797"

export default script